import { render, staticRenderFns } from "./PlanificacioNavTreeviewItem.vue?vue&type=template&id=3a819f27&scoped=true&"
import script from "./PlanificacioNavTreeviewItem.vue?vue&type=script&lang=js&"
export * from "./PlanificacioNavTreeviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a819f27",
  null
  
)

export default component.exports